export default "__VITE_ASSET__204aec6d__"